import { observer } from 'mobx-react-lite'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { InputField } from '@/components/fields/input-field'
import { Label, labelVariants } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { BookingLocation } from '@/lib/stores/booker-store'
import { RootStoreContext } from '@/lib/stores/root-store'
import { cn } from '@/lib/utils'

type Props = {
  readOnly?: boolean
  bookingLocation: BookingLocation
  control: any
  watch: any
}

export const BookerBookingFormLocationSelector = observer(
  ({ control, bookingLocation, readOnly, watch }: Props) => {
    const { t } = useTranslation()
    const {
      bookerStore: { selectedLocation },
    } = useContext(RootStoreContext)
    const [open, setOpen] = useState(false)

    const locationValue = watch('locationValue')

    // TODO: Currently we ONLY support single locations; This will be updated (See <Select> always disabled)
    return (
      <div className="mb-4">
        {/* Event Type Selector Component */}
        <div className="mb-2">
          <Label
            className={cn(labelVariants(), 'text-foreground')}
            htmlFor="location"
          >
            {t('location')}
          </Label>
        </div>

        <Select
          name="location"
          disabled={true}
          open={open}
          onOpenChange={setOpen}
          value={selectedLocation?.type.toString()}
          defaultValue={bookingLocation.type.toString()}
        >
          <SelectTrigger>
            <SelectValue
              placeholder={selectedLocation?.label || t('select_an_event')}
            />
          </SelectTrigger>

          <SelectContent className="max-h-[250px]">
            <SelectItem
              key={bookingLocation.label}
              value={bookingLocation?.type.toString() || ''}
            >
              {bookingLocation.label}{' '}
              {(selectedLocation?.type === 'LINK' ||
                selectedLocation?.type === 'ATTENDEE_IN_PERSON' ||
                selectedLocation?.type === 'HOST_PHONE') &&
              !!locationValue
                ? `(${locationValue})`
                : ''}
            </SelectItem>
          </SelectContent>
        </Select>

        <div>
          {/* These Location Types Have Inputs from Attendee */}
          {selectedLocation?.type === 'HOST_IN_PERSON' && (
            <InputField
              className="mt-2"
              control={control}
              name="locationValue"
              placeholder={t('enter_address')}
              disabled={readOnly}
            />
          )}

          {selectedLocation?.type === 'ATTENDEE_PHONE' && (
            <InputField
              className="mt-2"
              control={control}
              name="locationValue"
              placeholder="E.g. +61 412 345 678"
              disabled={readOnly}
            />
          )}
        </div>
      </div>
    )
  },
)
